class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.updateSortValueHref();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    let self = this;
    if (this.querySelector('.mobile-facets__close')) {
      this.querySelector('.mobile-facets__close').addEventListener('click', function () {
        self.closePopupFilter();
      });
    }

    this.querySelectorAll('.vegan-filter').forEach((item) => {
      item.addEventListener('change', function () {
        self.querySelectorAll('.filter-duplicate-vegan').forEach((v) => {
          v.checked = item.checked;
        });
      });
    });
  }

  closePopupFilter() {
    this.closest('.mobile-facets__disclosure')?.removeAttribute('open');
    this.closest('.mobile-facets__disclosure')?.classList.remove('menu-opening');
    this.closest('.mobile-facets__disclosure')
      ?.querySelector('.mobile-facets__open-wrapper')
      .removeAttribute('aria-expanded');
    document.querySelector('body').classList.remove('overflow-hidden-mobile');
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (typeof initializeCollectionSizeFilter === 'function') {
      initializeCollectionSizeFilter();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event?.target?.closest?.('.js-filter');
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const sortDetails = document.querySelector('facet-sort details');
    const shouldKeepOpen = sortDetails?.hasAttribute('data-keep-open') && sortDetails?.open;
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    const newSortDetails = document.querySelector('facet-sort details');
    if (shouldKeepOpen && newSortDetails) {
      newSortDetails.open = true;
      newSortDetails.setAttribute('data-keep-open', 'true');
    }
    let url = new URL(window.location.href);
    url.searchParams.delete('sort_by');
    const sortValueLink = document.querySelector('.facets-result .sort-value a');
    if (sortValueLink) {
      sortValueLink.href = url.toString();
    }

    if (typeof initializeCollectionSizeFilter === 'function') {
      initializeCollectionSizeFilter();
    }
  }
  updateSortValueHref() {
    let url = new URL(window.location.href);
    url.searchParams.delete('sort_by');
    const sortValueLink = document.querySelector('.facets-result .sort-value a');
    if (sortValueLink) {
      sortValueLink.href = url.toString();
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value !== null && value !== '') {
        params.append(key, value);
      }
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      const formId = form.id;
      if (
        formId === 'FacetFiltersForm' ||
        formId === 'FacetSortForm' ||
        formId === 'FacetSortDrawerForm' ||
        formId === 'FacetFiltersFormMobile'
      ) {
        const noJsElements = form.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(form));
      }
    });
    const searchParams = forms.join('&');
    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeSliderPrice();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
    const numberS = this.querySelectorAll('input[type=number]');
    let value1 = numberS[0].value;
    let value2 = numberS[1].value;

    this.updateDisplay(value1, value2);
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  rangeSliderPrice() {
    var rangeS = this.querySelectorAll('input[type=range]'),
      numberS = this.querySelectorAll('input[type=number]');

    rangeS.forEach((element, index) => {
      element.oninput = () => {
        let slide1 = parseFloat(rangeS[0].value);
        let slide2 = parseFloat(rangeS[1].value);
        const minGap = 5;

        if (index === 0 && slide1 >= slide2 - minGap) {
          slide1 = slide2 - minGap;
          rangeS[0].value = slide1;
        }

        if (index === 1 && slide2 <= slide1 + minGap) {
          slide2 = slide1 + minGap;
          rangeS[1].value = slide2;
        }

        numberS[0].value = slide1;
        numberS[1].value = slide2;
        this.updateDisplay(slide1, slide2);
        this.updatePrice(slide1, slide2);
      };
    });
  }

  updateDisplay(value1, value2) {
    const range = this.querySelector('input[type=range]');
    const priceSlideRangeContainer = this.querySelector('.facets__price--slide');
    const max = range.max;
    // const width = priceSlideRangeContainer.clientWidth;
    const width = 322;

    const leftSpace = (parseInt(value1) / parseInt(max)) * width + 'px';
    const rightSpace = width - (parseInt(value2) / parseInt(max)) * width + 'px';

    let range_slider = document.querySelector('.filter__price_max');
    let hint = document.querySelector('.label__filter-max');
    let range_slider_min = document.querySelector('.filter__price_min');
    let hint_min = document.querySelector('.label__filter-min');

    let thumbnWidth = 8;

    let offset = width / (parseInt(range_slider.max) - parseInt(range_slider.min));

    this.updatePosition(range_slider, offset, hint, thumbnWidth);
    this.updatePosition(range_slider_min, offset, hint_min, thumbnWidth);

    priceSlideRangeContainer.style.setProperty('--left-space', leftSpace);
    priceSlideRangeContainer.style.setProperty('--right-space', rightSpace);
  }

  updatePosition(range_slider, offset, hint, thumbnWidth) {
    hint.innerHTML = range_slider.value + '€';
    hint.style.top = range_slider.offsetHeight - 26 + 'px';
    hint.style.left =
      (range_slider.valueAsNumber - parseInt(range_slider.min)) * offset -
      hint.offsetWidth / 2 -
      (range_slider.valueAsNumber / parseInt(range_slider.max) - parseInt(range_slider.min) - 0.5) * thumbnWidth +
      'px';
  }

  updatePrice(min, max) {
    const $currentMin = document.querySelector('.money--current-min');
    const $currentMax = document.querySelector('.money--current-max');
    const $labelMin = document.querySelector('.label__filter-min .text');
    const $labelMax = document.querySelector('.label__filter-max .text');

    if ($currentMin) $currentMin.innerHTML = min;
    if ($currentMax) $currentMax.innerHTML = max;
    if ($labelMin) $labelMin.innerHTML = min;
    if ($labelMax) $labelMax.innerHTML = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
class FacetSort extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelectorAll('.facets__sort-option').forEach((element) => {
      element.addEventListener('click', this.onSortChange.bind(this));
    });
  }
  onSummaryClick(event) {
    const details = event.target.closest('details');
    const form = document.getElementById('FacetsWrapperDesktop');
    if (!details.hasAttribute('open') && form && form.classList.contains('active')) {
      document.querySelector('facet-open').click();
    }
  }
  onSortChange(event) {
    event.preventDefault();
    this.querySelectorAll('.facets__sort-option').forEach((element) => {
      element.classList.remove('selected');
    });
    event.currentTarget.classList.add('selected');
    let select = this.container.querySelector('select[name="sort_by"]');
    select.value = event.currentTarget.dataset.value;
    select.dispatchEvent(
      new Event('input', {
        bubbles: true,
        cancelable: true,
      })
    );
    const details = this.querySelector('details');
    if (details) {
      details.setAttribute('open', true);
      details.setAttribute('data-keep-open', true);
    }
  }
}
customElements.define('facet-sort', FacetSort);
